module.exports = __webpack_public_path__ + "img/Bahnhof_Sibiu_kl.ccf1384f.jpg";